import { Injectable } from '@angular/core';
import { AccountsService } from './accounts.service';
import { EventService } from './event.service';
import { SettingsService } from './settings.service';
import { UserService } from './user.service';
// import { ActivityService } from './activity.service';
// import { ContactsService } from './contacts.service';
import { EventPermissionsService } from './event.permissions.service';
// import { NoticesService } from './notices.service';
// import { NotificationsService } from './notifications.service';
import { ProgramService } from './program.service';
// import { ShareService } from './share.service';
// import { InformablesService } from './informables.service';
// import { TaskService } from './task.service';
import { Store } from '@ngrx/store';
import { eventsFeature, JoiEvent } from '../store/events.era';
import { userFeature } from '../store/user.era';
import { OnReset, Transitions } from './transition.service.helpers';
// import { BudgetService } from './budget.service';
// import { BackupService } from './backup.service';
// import { AppService } from './app.service';
import { User } from 'globals/store/user.data';
import { ActivityService } from './activity.service';
import { ShareService } from './share.service';
import { ContactsService } from './contacts.service';
import { NotificationsService } from './notifications.service';
import { TaskService } from './task.service';
import { InformablesService } from './informables.service';
import { BudgetService } from './budget.service';
import { BackupService } from './backup.service';
import { AppService } from './app.service';
import { NoticesService } from './notices.service';

@Injectable({ providedIn: 'root' })
export class TransitionService {

  private _userId
  private _eventId
  private subscribedServices: OnReset[]

  constructor(
    private eventService: EventService,
    private eventPermissionsService: EventPermissionsService,
    private userService: UserService,
    private programService: ProgramService,
    private settingsService: SettingsService,
    private activityService: ActivityService,
    private contactsService: ContactsService,
    private noticesService: NoticesService,
    private notificationsService: NotificationsService,
    private taskService: TaskService,
    private shareService: ShareService,
    private informablesService: InformablesService,
    private budgetService: BudgetService,
    private backupService: BackupService,
    private appService: AppService,
    public store: Store,
  ) {

    // TODO:  Add the following services in:
    // notificationsService <== not complete, it seems
console.log("Transition Service Constructed")
    this.subscribedServices = [
      this.eventPermissionsService,
      this.eventService,
      this.programService,
      this.settingsService,
      this.activityService,
      this.contactsService,
      this.informablesService,
      this.noticesService,
      this.shareService,
      this.taskService,
      this.budgetService,
      this.backupService,
      this.appService
    ]


    this.store.select(userFeature.selectUser).subscribe(user => {
      if (user.uid && !this._userId) { // login
        this._userId = user.uid
        this.onEnterUser(user)
      }
    })

    this.userService.loggedOut$.subscribe(loggedOut => { // get logged out notification before update to store
      this._userId = null
      this.onExitUser()
    })

    this.store.select(eventsFeature.selectEvent ).subscribe(event => {
      if (event && event.eventId && !this._eventId) {
        this._eventId = event.eventId
        this.onEnterEvent(event)
      } else if (!event && this._eventId) {
        this._eventId = null
        this.onExitEvent()
      }
    })
  }


  onEnterEvent(event: JoiEvent) {
    console.log("On Enter Event...")
    this.subscribedServices.forEach(service => service.onReset(Transitions.OnEnterEvent, event))
  }

  onExitEvent() {
    console.log("On Leave Event...")
    this.subscribedServices.forEach(service => service.onReset(Transitions.OnExitEvent))
  }

  onEnterUser(user: User) {
    console.log("On Enter User...")
    this.subscribedServices.forEach(service => service.onReset(Transitions.OnEnterUser, user))
  }

  onExitUser() {
    console.log("On Exit User...")
    this.subscribedServices.forEach(service => service.onReset(Transitions.OnExitUser))
  }

}



/*

Template to copy to services:

implements OnReset

onReset(resetType, value = null) {
  switch (resetType) {
    case resetTypes.OnEnterUser:
      break;
    case resetTypes.OnExitUser:
      break;
    case resetTypes.OnEnterEvent:
      break;
    case resetTypes.OnExitEvent:
      break;
    default:
      break;
  }
}

*/
